'use client';

import { useEffect, useState } from 'react';

import { createSPASassClient } from '@/lib/supabase/client';

/**
 * Hook to check if the current user is authenticated.
 * Useful for conditionally rendering auth-aware UI elements on public pages
 * (like landing page navbar/footer) that don't have access to AppUserContext.
 */
export function useIsAuthenticated() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const supabase = await createSPASassClient();
        const {
          data: { user },
        } = await supabase.getSupabaseClient().auth.getUser();
        setIsAuthenticated(!!user);
      } catch (error) {
        console.error('Error checking auth status:', error);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  return { isAuthenticated, loading };
}
